
export default {
  apiKey: "AIzaSyAbKOA-eV9bTm0JJNihoQt90A60DTAYqhw",
  authDomain: "mogu-98cbd.firebaseapp.com",
  projectId: "mogu-98cbd",
  storageBucket: "mogu-98cbd.appspot.com",
  messagingSenderId: "1063107748233",
  appId: "1:1063107748233:web:305658d8546296a64f8158"
};

